<template>
  <div>
    <div class="background"></div>
    <Header></Header>
    <div class="main">
      <el-row class="middle">
        <el-col class="middleRight">
          <el-row type="flex" justify="center">
            <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
              <div class="newsdetail-main">
                <div class="detailArea">
                  <h2 class="title">{{title}}</h2>
                  <div class="author">
                    <div class="publishing">发布单位：{{publishing}}</div>
                    <div class="pubtime">发布时间：{{time}}</div>
                  </div>
                  <div class="content" v-html="content"></div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <Footer></Footer>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        title: '',
        intr: '',
        time: '',
        content: '',
        publishing: ''
      };
    },

    components: {},

    mounted() {
      this.getDynamic()
      // this.getNews();
    },

    methods: {
      //根据id获取新闻详情
      getDynamic() {
        this.instance.get('/api/dynamic/dynamicdetail', {
          params: {
            id: this.$route.query.id
          }
        }).then(res => {
          if (res.status == 200) {
            var data = res.data;
            this.title = data.title;
            this.intr = data.intr;
            this.time = data.time;
            this.content = data.content;
            this.publishing = data.editor;
          }
        })
      },
      // getNews() {
      //   var id = this.$route.query.id;
      //   if (id) {
      //     this.$axios.get('http://www.csaln.cn/api/newsdetail', {
      //       params: {
      //         id: id
      //       }
      //     }).then(res => {
      //       if (res.status == 200) {
      //         var data = res.data;
      //         this.title = data.title;
      //         this.intr = data.intr;
      //         this.time = data.time;
      //         this.content = data.content;
      //         console.log('11111',this.content)
      //         this.publishing = data.editor;
      //       }
      //     })
      //   }
      // },




    },

  }
</script>
<style scoped>
  * {
    margin: 0;
    padding: 0;
  }


  .content {
    overflow: auto;
  }

  .content>>>img {
    max-width: 100%;
  }

  .newsdetail-main {
    position: relative;
    /* width: 1200px; */
    margin: 60px auto;
    /* background-color: rgba(255, 255, 255, 0.85) */
    background-color: rgba(255, 255, 255);
    border: 0.1vw solid rgb(60, 74, 93, .2);
    box-shadow: 0 0.3vw 0.4vw rgba(0, 0, 0, .12), 0 0 0.6vw rgba(0, 0, 0, .04);
  }

  .detailArea {
    width: 100%;
    padding: 40px 40px;
  }

  .title {
    text-align: center;
    color: #3C4A5D;
  }

  .author {
    text-align: center;
    margin: 10px 0 20px 0;
  }

  .author>.publishing {
    color: #3C4A5D;
    margin-right: 40px;
  }

  .author>.pubtime {
    color: #9E9FA0;
  }

  .pubtime {
    display: inline-block;
  }

  .publishing {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/views/DynamicDetail.vue